import { InjectionToken, Signal } from '@angular/core';

export interface SscDropdownPinStore {
  readonly pins: Signal<Readonly<Record<string, readonly (string | number)[]>>>;
  toggle(pinKey: string, value: string | number): void;
}

/** Optional. When provided with a dropdown `pinKey`, the modal shows swipe-to-pin. */
export const SSC_DROPDOWN_PIN_STORE = new InjectionToken<SscDropdownPinStore>(
  'SSC_DROPDOWN_PIN_STORE',
);
